import type { CrmWebhookLog } from "../../../api/crm-webhook-logs.service.js";

export type StashPrefill = {
  crmEntityNumber: string | null;
  suggestedName: string;
};

export function deriveStashPrefill(log: CrmWebhookLog | null): StashPrefill {
  if (log === null) {
    return { crmEntityNumber: null, suggestedName: "" };
  }

  const crmEntityNumber = log.crmFirmId?.trim() || null;
  const suggestedName =
    typeof log.rawPayload.suggestedFirmName === "string" ? log.rawPayload.suggestedFirmName : "";

  return { crmEntityNumber, suggestedName };
}
